// PeptideVault v6.5 — File import/export operations

// ══════════════════════════════════════════════════════
// FILE OPERATIONS
// ══════════════════════════════════════════════════════
async function addDocumentFile(opts = {}) {
  if (!window.api) {
    if (isElectron) {
      showToast('⚠️ Update preload.js — copy all 3 files from the zip', 5000)
    } else {
      showToast('File operations require the desktop app')
    }
    return null
  }
  const filePath = await window.api.pickFile({
    title: 'Select Document',
    filters: [
      { name: 'Documents', extensions: ['pdf','png','jpg','jpeg','docx','doc','txt'] },
      { name: 'All Files', extensions: ['*'] }
    ]
  })
  if (!filePath) return null
  const vaultDir = await window.api.getDataDir()
  const fileName = filePath.split(/[\/\\]/).pop()
  const destName = `files${SEP()}${uid()}_${fileName}`
  const destPath = `${vaultDir}${SEP()}${destName}`
  const copied = await window.api.copyFile(filePath, destPath)
  if (!copied?.ok) {
    showToast('Could not import document: ' + (copied?.error || 'Copy failed'), 5000)
    return null
  }
  const doc = {
    id: 'd_' + uid(),
    name: opts.name || fileName.replace(/\.[^.]+$/,''),
    type: opts.type || 'other',
    filePath: destName,
    originalName: fileName,
    notes: opts.notes || '',
    addedAt: now()
  }
  S.documents.push(doc)
  await save()
  return doc
}

async function openDocFile(doc) {
  if (!doc?.filePath) { showToast('COA PDF is not linked'); return }
  if (window.api) {
    const vaultDir = await window.api.getDataDir()
    const relative = String(doc.filePath).split(/[\\/]+/).filter(Boolean).join(SEP())
    const full = `${vaultDir}${SEP()}${relative}`
    const exists = await window.api.fileExists(full)
    if (!exists) { showToast('COA PDF file was not found'); return }
    const result = await window.api.openFile(full)
    if (!result?.ok) showToast('Could not open COA PDF: ' + (result?.error || 'Unknown error'), 5000)
  } else {
    showToast('File opening requires the desktop app')
  }
}

async function verifyDocumentFiles() {
  if (!window.api || !isElectron) { S._missingDocumentFiles = []; return [] }
  const vaultDir = await window.api.getDataDir()
  const missing = []
  for (const doc of (S.documents || [])) {
    if (!doc.filePath) continue
    const relative = String(doc.filePath).split(/[\\/]+/).filter(Boolean).join(SEP())
    if (!await window.api.fileExists(`${vaultDir}${SEP()}${relative}`)) missing.push(doc)
  }
  S._missingDocumentFiles = missing
  return missing
}

export {
  addDocumentFile,
  openDocFile,
  verifyDocumentFiles
}
